import {AbstractExport} from "./AbstractExport";
import {global, lm} from "../../../appContext";
import {ICompanySyncstep, IExportTemplate, IHistory, IMessageData, IRouteDefinitionParams} from "../../../index";
import {MAX_RESULTS_PER_PAGE, ObjectTypeId} from "../../../constants";
import PromiseRequest from "../../../req/PromiseRequest";
import {createErrorMessage, getObjectDefinition} from "../../../util/misc";
import {xhrFactory} from "../../../util/request";
import {REQUEST_MESSAGE} from "../../../constants/Language";
import {nsRoute} from "../../../util/route";
import * as ko from 'knockout'
import ButtonOrder = nsRoute.ButtonOrder;
import syncstepHtml from './syncstep.html?raw';

export let template: string = syncstepHtml;

export class viewModel extends AbstractExport {

    private _companysyncid!: number;
    private _companysyncstep!: ICompanySyncstep;
    private reqFullExport: PromiseRequest = new PromiseRequest("fullexport");
    private reqGetCompanySyncsteps: PromiseRequest = global.getPromiseRequest("getcompanysyncsteps");
    private objectTypeIds: ObjectTypeId[] = [ObjectTypeId.User, ObjectTypeId.Department, ObjectTypeId.Group, ObjectTypeId.FormData]
    private syncstepname: KnockoutObservable<string | null> = ko.observable(null);

    constructor(params: IRouteDefinitionParams) {
        super(params);

        this.pageButtons.add({
            validator: this.isReady,
            onClick: this.onPreviewClick.bind(this),
            enabled: () => this.isValid() && !this.isRequesting(),
            icon: 'fa-eye',
            label: 'preview',
            order: ButtonOrder.PREVIEW,
        })
        this.pageButtons.add({
            onClick: this.onExecuteClick.bind(this),
            cssClass: 'danger btn-ready-calm',
            enabled: () => this.isValid() && !this.isRequesting(),
            icon: 'fa-play',
            label: 'execute',
            order: ButtonOrder.SUBMIT,
            validator: this.isReady,
        })

        this.selectedObjectTypeId(null)

        this.initRequest();
    }

    protected initRequest() {
        this.isReady(false);
        this.messageData({message: REQUEST_MESSAGE});

        this._companysyncid = parseInt(this.__routeParams?.['id'] ?? '', 10);

        this.reqGetCompanySyncsteps
            .request({
                id: this._companysyncid
            })
            .then((data: ICompanySyncstep[]) => {
                const companysyncstep = data.find((item: ICompanySyncstep) => item.id == this._companysyncid);
                if (!companysyncstep) {
                    throw "Synchronization step not found.";
                }
                this._companysyncstep = companysyncstep;
                this.syncstepname(this._companysyncstep.syncstep.name)
                if (!this._companysyncstep.syncstep.isexportable) {
                    throw "Synchronization step is not exportable.";
                }
            })
            .then(() => {

                return this.reqSearchExportTemplate
                    .request({
                        asc: true,
                        pagenr: 0,
                        resultsprpage: MAX_RESULTS_PER_PAGE,
                        searchkey: "",
                        sortcol: "name"
                    })
                    .then((data: IExportTemplate[]) => {
                        this.exportTemplates = data.filter((item: IExportTemplate) => item.syncstep.id == this._companysyncid);
                    })
            })
            .then(() => {
                this.messageData(null);
                this.isReady(true);
            })
            .catch((reason: string) => {
                this.messageData(createErrorMessage(String(reason)));
            });
    }

    protected warnBeforeExecute(preview: boolean) {
        const strAction = preview ? "preview export" : "execute export"
        const content = `<p>${lm.t(preview ? "warning: preview export syncstep|br" : "warning: execute export syncstep|br")}</p><p>${lm.t(`do you wish to continue`)}</p>`
        global.dialogManager.addConfirm({
            title: `((${strAction})) [${this._companysyncstep.syncstep.name}]`,
            content: content,
            buttons: {
                cancel: {
                    label: `no, cancel`,
                },
                confirm: {
                    label: `yes, continue`,
                    onClick: this.execute.bind(this, preview),
                    cls: preview ? undefined : 'btn-danger',
                }
            }
        });
    }

    isExportTemplateSelected(item: IExportTemplate): boolean {
        if (!this.selectedObjectTypeId()) {
            return true;
        }

        return this.selectedObjectTypeId() == item.objecttype.id;
    }

    private isValid(): boolean {
        return !!this.exportTemplates.find(o => this.isExportTemplateSelected(o))
    }

    protected override execute(preview: boolean) {
        super.execute(preview);

        this.reqFullExport
            .request({
                companysyncstepid: this._companysyncstep.id,
                test: preview,
                objecttypeid: this.selectedObjectTypeId() || 0
            }, false, {
                timeout: 30 /*min*/ * 60 /*sec*/ * 1000 /*ms*/,
                xhr: xhrFactory(this.percentComplete as KnockoutObservable<number>, this.messageDataResult as KnockoutObservable<IMessageData>),
            })
            .then((data: IHistory[]) => {
                this.percentComplete(null);
                this.allTotal(data.length);
                this.exportActions(data);
                this.isDataReady(!!data.length);
                this.messageDataResult(data.length ? null : {message: 'no data'});
                this.isRequesting(false);
                if (!preview) {
                    const message = 'export completed';
                    global.snackbarData({message: message});
                }
            })
            .catch((reson: string) => {
                this.percentComplete(null);
                this.isDataReady(false);
                this.isRequesting(false);
                this.messageDataResult(createErrorMessage(reson))
            });
    }

    private getObjectDefinition = getObjectDefinition

    override dispose() {
        super.dispose();
        this.reqFullExport.abort();
        this.reqGetCompanySyncsteps.abort();
        this.reqSearchExportTemplate.abort();
    }

}
